import React from 'react';
import dayjs from 'dayjs';
import ICSChecklist from './ICSChecklist';
import { ActionEntity } from './hooks/useScopedActionForm';

interface ActionExpandedRowProps {
  row: ActionEntity;
}

const formatDate = (date: Date | string | null | undefined) =>
  date && dayjs(date).isValid() ? dayjs(date).format('MM/DD/YYYY HH:mm') : '—';

const Field: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <div className="d-flex flex-column mb-2 me-4">
    <div className="text-muted mt-1 mb-1 small">{label}</div>
    <span>{children}</span>
  </div>
);

const ActionExpandedRow: React.FC<ActionExpandedRowProps> = ({ row }) => {
  const checklist = row.checklist ?? [];
  const pocName =
    (row as any).poc_user_name || (row as any).user_name || row.poc || '—';

  return (
    <div className="p-2">
      <div className="d-flex flex-row flex-wrap mb-2">
        <Field label="DESCRIPTION">{row.description || '—'}</Field>
        <Field label="POINT OF CONTACT">{pocName}</Field>
        <Field label="BRIEFED POC">{row.briefed_poc ? 'Yes' : 'No'}</Field>
        <Field label="STATUS">{row.status || '—'}</Field>
        <Field label="START DATE">{formatDate(row.start_date)}</Field>
        <Field label="TARGET DATE">{formatDate(row.target_date)}</Field>
        <Field label="ACTUAL DATE">{formatDate(row.actual_date)}</Field>
      </div>
      {checklist.length > 0 && (
        <ICSChecklist checklist={checklist} setChecklist={() => {}} />
      )}
    </div>
  );
};

export default ActionExpandedRow;
